/* ============================================================================
   HDZS · OBALUS bundle-deal engine (sets agent). Vanilla JS, depends on window.HDZB (hdzb.js, loaded before this file).
   Rule (Rustam 02.10, replaces the owner's 30.09 unit tiers): by eligible subtotal — spend $50 → tier 1 (save $10) · spend
   $150 → tier 2 (save $30). Each tier = min units + min subtotal (Theme settings); units 1 = any count ("price mode": the
   track and the messages follow the subtotal — "Add $12.50 more to save $10").
   "Eligible" = cart units that are NOT: excluded products (theme settings: product list + handle list), products carrying the
   excluded tag ("Buy 1 Get 1"), deal lines (Kaching properties or an automatic line-level discount; a code's allocation is not a deal), technical products (warranty /
   shipping protection). A deal line in the cart blocks the bundle entirely while "stack with BOGO" is OFF.
   Mechanics: ONE code per reached tier via HDZB.cart.setDiscount → reads `applicable`; a code that does not apply is cleared
   and remembered per cart signature (no retry storm); a code the customer removed in UpCart is not re-applied for that cart
   state; a customer's own code is never touched; 429 from Shopify → backoff 5 s / 15 s / 45 s, then stop until the cart changes;
   more than 8 engine writes in 30 s → pause 2 min (loop fuse). Tiers are judged on the price before our own code.
   Never shows a saving the checkout won't honor.
   API: window.HDZS.state() · .refresh() · .paintTrack(el, state, {applied}) (tier track with markers) · .evaluate(lines, {withCart}) · .addSet(items, {attributes, open, toast}) · .paint()
        · .codeState(code) → 'applied' | 'dead' | 'ok' | 'unknown' · .canProject(code) (may a page show this tier's saving
          BEFORE the cart confirms it: confirmed this session, or Theme setting "codes are live" and not refused) · .message(state)
        · .tiers · .money(cents) · .usd(usdCents)
   A bare <div data-hdzs-progress data-context="drawer"></div> (e.g. pasted into an app's custom-HTML block) is built and filled too.
        · document event 'hdzs:bundle' (detail = state: {enabled, eligibleUnits, eligibleSubtotal, tier, saving, nextTier,
          unitsToNext, amountToNext, blockedByBogo, blockedByCode, code, applied, pending, message, …})
   ========================================================================== */
(function () {
  'use strict';
  if (window.HDZS && window.HDZS.__v) return;
  var CFG = window.HDZS_CFG || {};
  var MSG = CFG.msgs || {};
  var TIERS = (CFG.tiers || []).map(function (t, i) {
    return { n: i + 1, code: String(t.code || '').trim().toUpperCase(), amount: Number(t.amount) || 0, units: Number(t.units) || 0, min: Number(t.min) || 0 };
  }).filter(function (t) { return t.code && t.amount > 0 && t.units > 0; }).sort(function (a, b) { return (a.units - b.units) || (a.min - b.min); });
  TIERS.forEach(function (t, i) { t.n = i + 1; });
  /* price mode: every tier is reached by the subtotal alone (units ≤ 1, a minimum set) */
  var BY_PRICE = TIERS.length > 0 && TIERS.every(function (t) { return t.units <= 1 && t.min > 0; });
  var ENABLED = CFG.enabled !== false && TIERS.length > 0;
  var STACK = !!CFG.stackBogo;
  var READY = !!CFG.codesReady;   /* owner ticked "the codes exist in Discounts" → builder/quiz may project the saving before the cart confirms it */
  var EX_IDS = (CFG.excludedIds || []).map(Number);
  var EX_HANDLES = (CFG.excludedHandles || []).map(function (h) { return String(h).trim().toLowerCase(); }).filter(Boolean);
  var EX_TAG = String(CFG.excludedTag || '').trim().toLowerCase();
  var TECH_HANDLES = CFG.techHandles || [];
  var TECH_PREFIX = String(CFG.techTypePrefix || 'upcart').toLowerCase();
  var RETRY_MS = 10 * 60 * 1000;   /* a code that did not apply is not retried for the same cart state for 10 min */
  var BACKOFF = [5000, 15000, 45000];
  var FUSE_N = 8, FUSE_WINDOW = 30 * 1000, FUSE_PAUSE = 2 * 60 * 1000;   /* > 8 engine cart writes in 30 s = a loop, not a shopper → pause 2 min */
  var S = { __v: '1.4.1', tiers: TIERS, byPrice: BY_PRICE, cfg: CFG, codesReady: READY, freeShipUsdCents: Number(CFG.freeShipUsdCents) || 10000 };
  var root = (window.HDZB_CFG && window.HDZB_CFG.routes && window.HDZB_CFG.routes.root) || '/';
  if (root.length > 1 && root.slice(-1) === '/') root = root.slice(0, -1);
  if (root === '/') root = '';

  function H() { return window.HDZB; }
  function usd(c) { var h = H(); return h && h.usd ? h.usd(c) : Math.round(c); }
  function money(c) { var h = H(); return h && h.money ? h.money(c, { trim: true }) : '$' + (c / 100).toFixed(2); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fill(tpl, vars) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; }); }
  S.money = money; S.usd = usd;

  /* ---------- session memo (attempts per cart signature, suppressed codes, last verdict per code) ---------- */
  /* localStorage (not sessionStorage): the Facebook/Instagram webview opens every ad tap in a new session, and a fresh session
     re-tried a code Shopify had just refused (2 cart writes per page load). Entries older than 1 h are dropped. */
  var memo = { attempts: {}, suppressed: {}, verdict: {} };
  var MEMO_TTL = 60 * 60 * 1000;
  function store() { try { return window.localStorage; } catch (e) { return null; } }
  try {
    var m = JSON.parse((store() && store().getItem('hdzs_memo')) || 'null');
    if (m && m.attempts) {
      memo = m; memo.verdict = memo.verdict || {}; memo.suppressed = memo.suppressed || {};
      var t0 = Date.now();
      ['attempts', 'verdict'].forEach(function (k) { Object.keys(memo[k]).forEach(function (x) { if (!memo[k][x] || !(t0 - memo[k][x].at < MEMO_TTL)) delete memo[k][x]; }); });
    }
  } catch (e) { }
  function saveMemo() { try { store().setItem('hdzs_memo', JSON.stringify(memo)); } catch (e) { } }

  /* ---------- product tags (the excluded tag is resolved from /products/<handle>.js, cached) ---------- */
  var tagCache = {}, tagPending = {};
  Object.keys(CFG.cartTags || {}).forEach(function (h) { tagCache[h] = CFG.cartTags[h] || []; });
  try { var tc = JSON.parse(sessionStorage.getItem('hdzs_tags') || '{}'); Object.keys(tc).forEach(function (h) { if (!tagCache[h]) tagCache[h] = tc[h]; }); } catch (e) { }
  function saveTags() { try { sessionStorage.setItem('hdzs_tags', JSON.stringify(tagCache)); } catch (e) { } }
  function resolveTags(handles) {
    var missing = handles.filter(function (h, i) { return h && !tagCache[h] && !tagPending[h] && handles.indexOf(h) === i; });
    if (!missing.length) return Promise.resolve(false);
    return Promise.all(missing.map(function (h) {
      tagPending[h] = true;
      return fetch(root + '/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { tagCache[h] = (p && p.tags) || []; })
        .catch(function () { tagCache[h] = []; })
        .then(function () { delete tagPending[h]; });
    })).then(function () { saveTags(); return true; });
  }
  S.tagsOf = function (handle) { return tagCache[handle] || null; };

  /* ---------- classification + evaluation (pure) ---------- */
  function hasTag(tags) { return !!(EX_TAG && tags && tags.some(function (t) { return String(t).trim().toLowerCase() === EX_TAG; })); }
  function classify(line) {
    var handle = String(line.handle || '').toLowerCase(), type = String(line.product_type || line.type || '').toLowerCase();
    var tags = line.tags || tagCache[handle] || null;
    var props = line.properties || {};
    var tech = TECH_HANDLES.indexOf(handle) > -1 || (TECH_PREFIX && type.indexOf(TECH_PREFIX) === 0);
    var excluded = EX_IDS.indexOf(Number(line.product_id)) > -1 || EX_HANDLES.indexOf(handle) > -1;
    var tagged = hasTag(tags);
    var kaching = !!(props && (props.__kaching_bundles || props.__kaching_session_id));
    /* A deal = an automatic / app line discount (native BOGO arrives with type "", Kaching too). A CODE's allocation is not a
       deal: our tier codes are "Amount off products", so Shopify spreads them over the lines (type "discount_code", title =
       code) — counting that as a deal made the engine remove its own code and re-apply it in a loop (found 05.10). A customer's
       code is handled in run(). ours = what our code took off this line: added back so the tier is judged on the pre-code price,
       like Shopify's own minimum ($59.98 − $10 must not fall under $50). */
    var lineDisc = false, ours = 0;
    (line.line_level_discount_allocations || []).forEach(function (a) {
      var app = (a && a.discount_application) || {};
      if (app.type !== 'discount_code') { lineDisc = true; return; }
      if (isOurs(app.title || '')) ours += Number(a.amount) || 0;
    });
    return { tech: tech, excluded: excluded || tagged, deal: !!line.deal || kaching || lineDisc || tagged, unknown: !tags && !tech && !excluded && !line.deal, ours: ours };
  }
  /* lines: cart.js items or hypothetical {handle, product_id, product_type, quantity, price|final_line_price, tags?, deal?} */
  function evaluate(lines, opts) {
    opts = opts || {};
    lines = (lines || []).slice();
    if (opts.withCart && H() && H().cart.state) lines = lines.concat(H().cart.state.items || []);
    var dealProducts = {}, units = 0, subtotal = 0, dealUnits = 0, unknown = [], itemCount = 0;
    var cls = lines.map(function (l) { var c = classify(l); if (c.deal) dealProducts[l.product_id] = true; return c; });
    lines.forEach(function (l, i) {
      var c = cls[i], q = Number(l.quantity) || 0;
      var lineTotal = ((l.final_line_price != null) ? Number(l.final_line_price) : (Number(l.price) || 0) * q) + c.ours;
      if (c.tech) return;
      itemCount += q;
      if (c.deal || dealProducts[l.product_id]) { dealUnits += q; return; }
      if (c.excluded) return;
      if (c.unknown) unknown.push(l.handle);
      units += q; subtotal += lineTotal;
    });
    var hasDeal = dealUnits > 0;
    var blocked = ENABLED && hasDeal && !STACK;
    var tier = null;
    if (ENABLED && !blocked) {
      for (var i = TIERS.length - 1; i >= 0; i--) { var t = TIERS[i]; if (units >= t.units && subtotal >= usd(t.min)) { tier = t; break; } }
    }
    var next = null, unitsToNext = 0, amountToNext = 0;
    if (ENABLED && !blocked) {
      var idx = tier ? TIERS.indexOf(tier) + 1 : 0;
      if (idx < TIERS.length) { next = TIERS[idx]; unitsToNext = Math.max(0, next.units - units); amountToNext = Math.max(0, usd(next.min) - subtotal); }
    }
    return {
      enabled: ENABLED, stackBogo: STACK, currency: H() ? H().currency : 'USD',
      itemCount: itemCount, eligibleUnits: units, eligibleSubtotal: subtotal, dealUnits: dealUnits, hasDeal: hasDeal,
      tier: tier ? tier.n : 0, tierCode: tier ? tier.code : null, amount: tier ? usd(tier.amount) : 0,
      nextTier: next ? next.n : 0, nextCode: next ? next.code : null, nextAmount: next ? usd(next.amount) : 0, unitsToNext: unitsToNext, amountToNext: amountToNext,
      blockedByBogo: blocked, blockedByCode: false, foreignCode: null,
      code: tier ? tier.code : null, applied: false, pending: false, saving: 0, resolving: unknown.length > 0, unknownHandles: unknown,
      signature: [tier ? tier.n : 0, units, subtotal, hasDeal ? 1 : 0, itemCount].join(':')
    };
  }
  S.evaluate = evaluate;
  /* what this session learned about a code: 'applied' (on the live cart now) · 'ok' (Shopify accepted it earlier) · 'dead' (Shopify said it does not apply) · 'unknown' */
  S.codeState = function (code) {
    code = String(code || '').toUpperCase();
    if (!code) return 'unknown';
    if (state && state.applied && state.code === code) return 'applied';
    var v = memo.verdict[code];
    if (!v) return 'unknown';
    return v.applicable ? 'ok' : 'dead';
  };
  /* a projection (builder / quiz, before the set is in the cart) shows money off only when the checkout will honor it */
  S.canProject = function (code) {
    var cs = S.codeState(code);
    return cs === 'applied' || cs === 'ok' || (READY && cs !== 'dead');
  };

  /* ---------- message per state ---------- */
  function vars(st) {
    var t1 = TIERS[0], t2 = TIERS[1];
    return {
      a1: t1 ? money(usd(t1.amount)) : '', a2: t2 ? money(usd(t2.amount)) : (t1 ? money(usd(t1.amount)) : ''),
      m1: t1 && t1.min ? money(usd(t1.min)) : '', m2: t2 && t2.min ? money(usd(t2.min)) : '',
      min: t2 ? money(usd(t2.min)) : '', amount: st.nextAmount ? money(st.nextAmount) : (st.amount ? money(st.amount) : ''),
      n: st.unitsToNext, s: st.unitsToNext === 1 ? '' : 's', x: money(st.amountToNext), units: st.eligibleUnits, code: st.foreignCode || ''
    };
  }
  function message(st) {
    if (!st.enabled) return '';
    var v = vars(st);
    if (st.blockedByBogo) return fill(MSG.bogo, v);
    if (st.blockedByCode) return fill(MSG.code, v);
    if (st.tier > 0 && !st.applied) { v.amount = money(st.amount); return fill(MSG.pending, v); }   /* tier reached, code not honored (yet) → neutral, no saving shown */
    if (st.tier >= 2 || (st.tier > 0 && !st.nextTier)) return fill(MSG.t2, v);
    if (st.tier === 1) return st.unitsToNext > 0 ? fill(MSG.t1, v) : fill(MSG.t1amount, v);
    if (st.eligibleUnits > 0 && st.nextTier) return fill(st.unitsToNext > 0 || !MSG.nextAmount ? MSG.next : MSG.nextAmount, v);
    return fill(MSG.intro, v);
  }
  S.message = message;

  /* ---------- live state + sync with the real cart ---------- */
  var state = evaluate([]), inflight = false, timer = null, retryTimer = null, lastCart = null, backoffUntil = 0, backoffN = 0, backoffSig = '';
  state.message = message(state);
  function emit() {
    try { document.dispatchEvent(new CustomEvent('hdzs:bundle', { detail: state })); } catch (e) { }
    paint();
  }
  function isOurs(code) { return TIERS.some(function (t) { return t.code === String(code).toUpperCase(); }); }
  function attemptKey(st) { return st.signature + '|' + (st.tierCode || ''); }

  function run(cart) {
    if (!cart) return;
    lastCart = cart;
    var st = evaluate(cart.items || []);
    var codes = (cart.discount_codes || []).map(function (d) { return { code: String(d.code).toUpperCase(), applicable: !!d.applicable }; });
    var ours = codes.filter(function (c) { return isOurs(c.code); });
    var foreign = codes.filter(function (c) { return !isOurs(c.code); });
    var desired = (st.enabled && !st.blockedByBogo && st.tier > 0) ? st.tierCode : null;
    if (foreign.length) {                          /* the customer's own code: never replaced, never cleared */
      var fa = foreign.filter(function (c) { return c.applicable; })[0];
      st.foreignCode = foreign[0].code;
      if (fa) { st.blockedByCode = true; st.foreignCode = fa.code; }
      desired = null;
    }
    var have = ours.filter(function (c) { return c.code === st.tierCode; })[0];
    if (have) { st.applied = have.applicable; st.pending = !have.applicable; st.saving = have.applicable ? st.amount : 0; if (have.applicable) { memo.verdict[have.code] = { applicable: true, at: Date.now() }; } }
    else if (st.tierCode) { var a = memo.attempts[attemptKey(st)]; st.pending = !!(a && !a.applicable); }
    st.message = message(st);
    state = st;
    emit();
    if (st.resolving) { resolveTags(st.unknownHandles).then(function (changed) { if (changed) run(lastCart); }); return; }
    if (!st.enabled || inflight || foreign.length) return;
    if (Date.now() < backoffUntil) return;
    if (st.signature !== backoffSig) { backoffN = 0; backoffSig = st.signature; }
    var now = Date.now(), key = attemptKey(st);
    if (desired) {
      if (have) {
        if (!have.applicable) {                      /* present but Shopify says it does not apply → clear it, remember */
          /* A refused code can come back after our clear: another app's concurrent /cart/update.js (Kaching's session
             attribute, Intelligems' igId — both post on every page load) wrote back a cart that still carried it (seen 30.09).
             So a code that is still on the cart is cleared again — at most 3 times per cart state per 10 min (no loop). */
          var prev = memo.attempts[key], recent = !!(prev && prev.cleared && now - prev.at < RETRY_MS), n = recent ? (prev.clears || 1) : 0;
          if (n >= 3) return;
          memo.attempts[key] = { code: desired, applicable: false, cleared: true, clears: n + 1, at: recent ? prev.at : now }; memo.verdict[desired] = { applicable: false, at: now }; saveMemo();
          mutate(function () { return H().cart.clearDiscount(); });
        }
        return;
      }
      if (memo.suppressed[desired] === st.signature) { state.suppressed = true; return; }   /* the customer removed it in UpCart */
      var att = memo.attempts[key];
      if (att && att.code === desired && !att.applicable && now - att.at < RETRY_MS) return;
      /* Shopify refused this code < 10 min ago for another cart state that also reached its tier (our tiers mirror the code's
         own minimums, so "not applicable" = the code is missing/inactive) → don't spend two more cart writes re-asking. */
      var vd = memo.verdict[desired];
      if (vd && !vd.applicable && now - vd.at < RETRY_MS) return;
      mutate(function () {
        return H().cart.setDiscount(desired).then(function (res) {
          memo.attempts[key] = { code: desired, applicable: !!res.applied, cleared: !res.applied, at: Date.now() };
          memo.verdict[desired] = { applicable: !!res.applied, at: Date.now() }; saveMemo();
          if (!res.applied) return H().cart.clearDiscount();
          return res.cart;
        });
      });
    } else if (ours.length) {
      mutate(function () { return H().cart.clearDiscount(); });          /* dropped below the tier / deal line arrived → remove our code */
    }
  }
  var writes = [];
  function mutate(fn) {
    var t0 = Date.now();
    writes = writes.filter(function (t) { return t0 - t < FUSE_WINDOW; });
    if (writes.length >= FUSE_N) {
      backoffUntil = t0 + FUSE_PAUSE; writes = [];
      try { console.warn('[hdzs] too many cart writes in a row, paused for 2 min'); } catch (e) { }
      return;
    }
    writes.push(t0);
    inflight = true;
    var p;
    try { p = fn(); } catch (e) { p = Promise.reject(e); }
    Promise.resolve(p).then(function (c) {
      inflight = false; backoffN = 0;
      var cart = (c && c.items) ? c : (H().cart.state || lastCart);
      run(cart);
    }).catch(function (e) {
      inflight = false;
      var status = e && e.status;
      if (status === 429 || status === 503) {       /* Shopify rate limit on cart writes: 5 s → 15 s → 45 s, then wait for the next cart change */
        var wait = BACKOFF[Math.min(backoffN, BACKOFF.length - 1)];
        var give = backoffN >= BACKOFF.length;
        backoffN++;
        backoffUntil = Date.now() + (give ? RETRY_MS : wait);
        if (!give && !retryTimer) retryTimer = setTimeout(function () { retryTimer = null; S.refresh(); }, wait + 500);
      }
      state.error = (e && e.message) || String(e);
      emit();
    });
  }
  function schedule(cart) {
    clearTimeout(timer);
    timer = setTimeout(function () { run(cart || (H() && H().cart.state) || lastCart); }, 260);
  }

  S.state = function () { return state; };
  S.refresh = function () {
    if (!H()) return Promise.resolve(state);
    return H().cart.get().then(function (c) { run(c); return state; }).catch(function () { return state; });
  };
  /* one /cart/add.js for a whole set; optional cart attributes first (quiz answers) */
  S.addSet = function (items, o) {
    o = o || {};
    var list = (items || []).map(function (it) { return { id: Number(it.id), quantity: Number(it.quantity) || 1, properties: it.properties }; }).filter(function (it) { return it.id > 0; });
    if (!list.length) return Promise.reject(new Error('Nothing selected'));
    var pre = o.attributes ? H().cart.update({ attributes: o.attributes }).catch(function () { }) : Promise.resolve();
    return pre.then(function () { return H().cart.add(list, { open: o.open !== false, toast: o.toast }); });
  };

  /* ---------- progress lines: <div data-hdzs-progress data-context="pdp|cart|builder|drawer"> ---------- */
  var SVG = {
    tag: '<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>',
    ok: '<circle cx="12" cy="12" r="10"/><path d="m16 9-5.5 5.5L8 12"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>'
  };
  function ic(k) { return '<span class="hdzs-progress__ic hdzs-progress__ic--' + k + '" aria-hidden="true"><svg class="hdzb-i" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' + SVG[k] + '</svg></span>'; }
  function build(el) {   /* a bare placeholder (no Liquid snippet behind it) gets the same markup as snippets/hdzs-progress.liquid */
    var ctx = el.getAttribute('data-context') || 'drawer';
    ['hdzb', 'hdzs-progress', 'hdzs-progress--' + ctx].forEach(function (c) { el.classList.add(c); });
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<div class="hdzs-progress__t">' + ic('tag') + ic('ok') + ic('info') + '<span class="hdzs-progress__msg" data-hdzs-msg></span></div>' +
      (ctx === 'drawer' ? '' : '<div class="hdzs-track" data-hdzs-track aria-hidden="true"></div>');
  }
  /* ---------- tier track: a bar with one marker per tier (the next reward is highlighted) ----------
     pos(units): 0 → 0 %, tier-1 units → 50 %, top tier → 100 % (3 units under the subtotal minimum stop at 88 %).
     Price mode: the same 0 / 50 / 100 % stops by eligible subtotal (tier-1 minimum → 50 %, top minimum → 100 %).
     st: an evaluate()/state() object · opts.applied: the tier saving is honored (else reached markers stay neutral). */
  function trackPos(st) {
    if (!TIERS.length) return 0;
    if (BY_PRICE) {
      var sub = st.eligibleSubtotal || 0, m1 = usd(TIERS[0].min), mT = usd(TIERS[TIERS.length - 1].min);
      if (TIERS.length === 1 || sub <= m1) return Math.min(100, sub / Math.max(1, m1) * (TIERS.length === 1 ? 100 : 50));
      return 50 + Math.min(1, (sub - m1) / Math.max(1, mT - m1)) * 50;
    }
    var u = st.eligibleUnits || 0, t1 = TIERS[0], t2 = TIERS[TIERS.length - 1];
    if (TIERS.length === 1 || u <= t1.units) return Math.min(100, u / t1.units * (TIERS.length === 1 ? 100 : 50));
    var p = 50 + Math.min(1, (u - t1.units) / Math.max(1, t2.units - t1.units)) * 50;
    if (st.tier < TIERS.length && p >= 100) p = 88;
    return p;
  }
  function tierLabel(t) {
    var u = t.units <= 1 && t.min ? 'Spend ' + money(usd(t.min)) : (t.min ? t.units + '+ items from ' + money(usd(t.min)) : t.units + ' items');
    return '<span class="hdzs-track__u">' + u + '</span><b class="hdzs-track__a">Save ' + money(usd(t.amount)) + '</b>';
  }
  S.paintTrack = function (el, st, opts) {
    if (!el) return;
    opts = opts || {};
    var applied = opts.applied != null ? !!opts.applied : !!st.applied;
    if (!el.__built) {
      el.__built = true;
      el.classList.add('hdzs-track');
      var n = TIERS.length;
      el.innerHTML = '<div class="hdzs-track__bar"><i class="hdzs-track__fill"></i>' + TIERS.map(function (t, i) {
        var left = n === 1 ? 100 : (i === 0 ? 50 : 100);
        return '<span class="hdzs-track__mk" data-n="' + t.n + '" style="left:' + left + '%"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>';
      }).join('') + '</div><div class="hdzs-track__labels">' + TIERS.map(function (t, i) {
        return '<span class="hdzs-track__l hdzs-track__l--' + (i === TIERS.length - 1 ? 'end' : 'mid') + '" data-n="' + t.n + '">' + tierLabel(t) + '</span>';
      }).join('') + '</div>';
    }
    var blocked = !!(st.blockedByBogo || st.blockedByCode) || !st.enabled;
    /* a reached tier the checkout does not honor (code missing / not applicable) → no track: never show a saving that won't apply */
    el.hidden = blocked || (st.tier > 0 && !applied);
    el.classList.toggle('is-applied', applied && st.tier > 0);
    var fill = el.querySelector('.hdzs-track__fill');
    if (fill) fill.style.width = (blocked ? 0 : trackPos(st)) + '%';
    var nextN = st.nextTier || 0;
    Array.prototype.forEach.call(el.querySelectorAll('[data-n]'), function (m) {
      var n = Number(m.getAttribute('data-n'));
      var reached = st.tier >= n;
      m.classList.toggle('is-reached', reached);
      m.classList.toggle('is-won', reached && applied);
      m.classList.toggle('is-next', !reached && n === nextN);
    });
  };
  function paint() {
    $$('[data-hdzs-progress]').forEach(function (el) {
      if (!el.querySelector('[data-hdzs-msg]')) build(el);
      var st = state;
      if (!st.enabled) { el.hidden = true; return; }
      el.hidden = false;
      var msg = el.querySelector('[data-hdzs-msg]'), track = el.querySelector('[data-hdzs-track]');
      if (msg && msg.textContent !== (st.message || '')) {
        msg.textContent = st.message || '';
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      }
      el.classList.toggle('is-t1', st.tier === 1 && st.applied);
      el.classList.toggle('is-t2', st.tier >= 2 && st.applied);
      el.classList.toggle('is-blocked', !!(st.blockedByBogo || st.blockedByCode));
      el.classList.toggle('is-pending', !!(st.tier > 0 && !st.applied));
      el.classList.toggle('is-empty', st.eligibleUnits === 0 && !st.blockedByBogo);
      el.setAttribute('data-hdzs-state', st.blockedByBogo ? 'bogo' : st.blockedByCode ? 'code' : st.tier > 0 ? (st.applied ? 'tier' + st.tier : 'pending') : st.eligibleUnits > 0 ? 'progress' : 'empty');
      if (track) S.paintTrack(track, st);
    });
  }
  S.paint = paint;

  /* ---------- wiring ---------- */
  function boot() {
    if (!H()) { setTimeout(boot, 50); return; }
    window.addEventListener('hdzb:cart', function (e) { var d = e.detail || {}; if (d.cart) schedule(d.cart); });
    window.addEventListener('upcart:discount-remove', function (e) {
      var code = e.detail && e.detail.code ? String(e.detail.code).toUpperCase() : (state.code || '');
      if (code && isOurs(code)) { memo.suppressed[code] = state.signature; saveMemo(); }
    });
    window.addEventListener('upcart:discount-apply', function () { setTimeout(function () { S.refresh(); }, 600); });
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { var n = muts[i].addedNodes; for (var j = 0; j < n.length; j++) { var x = n[j]; if (x.nodeType === 1 && (x.hasAttribute('data-hdzs-progress') || x.querySelector('[data-hdzs-progress]'))) { paint(); return; } } }
      }).observe(document.body, { childList: true, subtree: true });
    }
    paint();
    var count = Number(window.HDZB_CFG && window.HDZB_CFG.cartCount) || 0;
    if (H().cart.state) run(H().cart.state); else if (count > 0) S.refresh(); else emit();
  }
  window.HDZS = S;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
